import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

export interface PayrollsCommentsDialogData {
  title: string;
  comments: string;
  comment_for_employee: string;
}

export interface PayrollsCommentsDialogResult {
  comments: string | null;
  comment_for_employee: string | null;
}

@Component({
  selector: 'app-payrolls-comments-dialog',
  templateUrl: './payrolls-comments-dialog.component.html',
  styleUrls: ['./payrolls-comments-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    CdkTextareaAutosize,
  ],
})
export class PayrollsCommentsDialogComponent {
  private readonly fb = inject(FormBuilder);
  private readonly dialogRef = inject(MatDialogRef<PayrollsCommentsDialogComponent, PayrollsCommentsDialogResult | undefined>);
  readonly data = inject<PayrollsCommentsDialogData>(MAT_DIALOG_DATA);

  readonly form: FormGroup = this.fb.group({
    comments: [this.data.comments],
    comment_for_employee: [this.data.comment_for_employee],
  });

  save(): void {
    const form_value = this.form.getRawValue();

    this.dialogRef.close({
      comments: form_value.comments.trim() || null,
      comment_for_employee: form_value.comment_for_employee.trim() || null,
    });
  }
}
